<template>
    <section class="pt-10" id="destination">
        <!-- Loader Overlay -->
        <div id="overlay" class="overlay" style="display: none;">
            <div id="loader" class="loader">
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="chat-container">
                <div class="requests-container">
                    <label>Requests</label>
                    <ul class="requests-list custom-scroll">
                        <li v-for="request in requests" :key="request.request.id" class="request-item"
                            @click="selectRequest(request)">
                            <div class="request-bubble">
                                <!-- 'New' or 'Opened' label -->
                                <span v-if="request.request.reqStatus === '0'"
                                    class="request-label new-label">New</span>
                                <span v-if="request.request.reqStatus === '1'"
                                    class="request-label opened-label">Opened</span>
                                <span v-if="request.request.reqStatus === '2'"
                                    class="request-label reply-label">Replied</span>
                                <span v-if="request.request.reqStatus === '3'"
                                    class="request-label closed-label">Closed</span>
                                <h4 class="request-title">Request #{{ request.request.id }}</h4>
                                <p><strong>Customer Name:</strong> {{ request.customer_name }}</p>
                            </div>
                        </li>
                    </ul>

                </div>

                <div class="chat-display custom-scroll">
                    <label>Request Details</label>
                    <div v-if="selectedRequest" class="message-bubble">
                        <div class="tour-detail">
                            <div class="col-12 mt-2 mb-2">
                                <div class="card shadow border-0">
                                    <div class="card-body">
                                        <!-- <h2 class="mb-3 mt-2 fw-bold text-primary">{{ place.name }}</h2> -->
                                        <h4 class="card-title text-primary mb-2 text-start mt-3">Customer Details
                                        </h4>

                                        <div class="card">
                                            <div class="row">
                                                <!-- Adults -->
                                                <div class="card col-md-12 mb-3">
                                                    <div class="card-body text-start">
                                                        <p class="card-text"><strong>Name</strong>: {{
                                                            selectedRequest.customer_name }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <img :src="'http://127.0.0.1:8000/images/' + place.coverImage" class="card-img-bottom"
                        alt="Cover Image" style="object-fit: cover; height: 300px;"> -->

                                </div>
                            </div>

                            <div class="col-12">
                                <div class="card shadow border-0">
                                    <div class="card-body">
                                        <!-- <h2 class="mb-3 mt-2 fw-bold text-primary">{{ place.name }}</h2> -->
                                        <h4 class="card-title text-primary mb-2 text-start mt-3">Booking Summary</h4>

                                        <div class="card">
                                            <div class="row">
                                                <!-- Adults -->
                                                <div class="card col-md-3 mb-3">
                                                    <div class="card-body text-center">
                                                        <p class="card-text"><strong>Adults</strong><br> 0{{
                                                            selectedRequest.request.tourDetail.adults }}</p>
                                                    </div>
                                                </div>
                                                <!-- Children -->
                                                <div class="card col-md-3 mb-3">
                                                    <div class="card-body text-center">
                                                        <p class="card-text"><strong>Children</strong><br> 0{{
                                                            selectedRequest.request.tourDetail.children }}
                                                        </p>
                                                    </div>
                                                </div>

                                                <!-- Check-in Date -->
                                                <div class="card col-md-3 mb-3">
                                                    <div class="card-body text-center">
                                                        <p class="card-text"><strong>Arrival Date</strong><br> {{
                                                            selectedRequest.request.tourDetail.check_in_date }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <!-- Check-out Date -->
                                                <div class="card col-md-3 mb-3">
                                                    <div class="card-body text-center">
                                                        <p class="card-text"><strong>Depature Date</strong><br> {{
                                                            selectedRequest.request.tourDetail.check_out_date
                                                            }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <img :src="'http://127.0.0.1:8000/images/' + place.coverImage" class="card-img-bottom"
                        alt="Cover Image" style="object-fit: cover; height: 300px;"> -->

                                </div>
                            </div>

                            <div class="col-12 mt-2">
                                <div class="card shadow border-0">
                                    <div class="card-body">
                                        <!-- <h2 class="mb-3 mt-2 fw-bold text-primary">{{ place.name }}</h2> -->
                                        <h4 class="card-title text-primary mb-2 text-start mt-3">Intrested Provinces
                                        </h4>

                                        <div class="card">
                                            <div class="row">
                                                <li v-for="(province, index) in selectedRequest.provinces" :key="index">
                                                    {{ province }}
                                                </li>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <img :src="'http://127.0.0.1:8000/images/' + place.coverImage" class="card-img-bottom"
                        alt="Cover Image" style="object-fit: cover; height: 300px;"> -->

                                </div>
                            </div>

                            <div class="col-12 mt-2">
                                <div class="card shadow border-0">
                                    <div class="card-body">
                                        <!-- <h2 class="mb-3 mt-2 fw-bold text-primary">{{ place.name }}</h2> -->
                                        <h4 class="card-title text-primary mb-2 text-start mt-3">Intrested Categories
                                        </h4>

                                        <div class="card">
                                            <div class="row">
                                                <li v-for="(category, index) in selectedRequest.categories"
                                                    :key="index">
                                                    {{ category }}
                                                </li>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <img :src="'http://127.0.0.1:8000/images/' + place.coverImage" class="card-img-bottom"
                        alt="Cover Image" style="object-fit: cover; height: 300px;"> -->

                                </div>
                            </div>
                            <div class="col-12 mt-2">
                                <div class="card shadow border-0">
                                    <div class="card-body">
                                        <!-- <h2 class="mb-3 mt-2 fw-bold text-primary">{{ place.name }}</h2> -->
                                        <h4 class="card-title text-primary mb-2 text-start mt-3">Intrested Activites
                                        </h4>

                                        <div class="card">
                                            <div class="row">
                                                <li v-for="(activity, index) in selectedRequest.request.tourDetail.activities"
                                                    :key="index">
                                                    {{ activity }}
                                                </li>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <img :src="'http://127.0.0.1:8000/images/' + place.coverImage" class="card-img-bottom"
                        alt="Cover Image" style="object-fit: cover; height: 300px;"> -->

                                </div>
                            </div>
                            <div class="col-12 mt-2">
                                <div class="card shadow border-0">
                                    <div class="card-body">
                                        <!-- <h2 class="mb-3 mt-2 fw-bold text-primary">{{ place.name }}</h2> -->
                                        <h4 class="card-title text-primary mb-2 text-start mt-3">Special Activites
                                        </h4>

                                        <div class="card">
                                            <div class="row">
                                                <span v-if="selectedRequest.request.tourDetail.special_activities">
                                                    {{
                                                        selectedRequest.request.tourDetail.special_activities }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <img :src="'http://127.0.0.1:8000/images/' + place.coverImage" class="card-img-bottom"
                        alt="Cover Image" style="object-fit: cover; height: 300px;"> -->

                                </div>
                            </div>
                            <div class="col-12 mt-2">
                                <div class="card shadow border-0">
                                    <div class="card-body">
                                        <!-- <h2 class="mb-3 mt-2 fw-bold text-primary">{{ place.name }}</h2> -->
                                        <h4 class="card-title text-primary mb-2 text-start mt-3">Special Requirements
                                        </h4>

                                        <div class="card">
                                            <div class="row">
                                                <span v-if="selectedRequest.request.tourDetail.special_requirements">
                                                    {{
                                                        selectedRequest.request.tourDetail.special_requirements }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <img :src="'http://127.0.0.1:8000/images/' + place.coverImage" class="card-img-bottom"
                        alt="Cover Image" style="object-fit: cover; height: 300px;"> -->

                                </div>
                            </div>
                        </div>

                        <div class="col-12 text-center mt-5">
                            <h4>--- Make a quotation for customer ---</h4>
                            <textarea v-model="reply"
                                class="mt-3 form-control" style="height: 300px; border-radius: 5px;" id="reply"
                                name="reply" placeholder="Type something here..." :disabled="isDisabled">
                                </textarea>
                        </div>
                        <!-- Submit Button -->
                        <div class="row mb-4 mt-4">
                            <div class="col-12 text-center">
                                <button class="col-12 btn btn-primary fw-1000" id="makeQuotation"
                                    @click="makeQuotation(selectedRequest)" :disabled="isDisabled">
                                    Submit your quotation for customer
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <p class="no-message">Select a request to view details.</p>
                    </div>


                </div>

            </div>
        </div>
    </section>
</template>

<script>
import $ from 'jquery';
import Swal from 'sweetalert2'; // Import SweetAlert2

export default {
    name: 'OrgRequestList',
    data() {
        return {
            requests: [], // Array to hold organization requests
            selectedRequest: null, // Holds the selected request details
            reply: null,
            isDisabled: false,

        };
    },
    mounted() {
        this.fetchRequests(); // Fetch requests when the component mounts

    },
    methods: {
        fetchRequests() {
            // Example AJAX call to get requests (replace with your API endpoint)
            const user = JSON.parse(localStorage.getItem('user'));
            const cusId = user?.id;
            if (!cusId) {
                console.error('Customer ID not found in local storage');
                return;
            }
            $.ajax({
                url: process.env.VUE_APP_API_URL +`/getRequests/${cusId}`,
                method: 'GET',
                success: (data) => {
                    this.requests = data; // Assume the response contains an array of requests
                },
                error: (error) => {
                    console.error('Error fetching organization requests:', error);
                }
            });
        },
        selectRequest(request) {
            this.selectedRequest = request; // Set the selected request

            // Ensure tourDetail is in the correct format if it's a JSON string
            if (typeof this.selectedRequest.request.tourDetail === 'string') {
                this.selectedRequest.request.tourDetail = JSON.parse(this.selectedRequest.request.tourDetail);
            }

            if (typeof this.selectedRequest.request.guideReply === 'string') {
                this.selectedRequest.request.guideReply = JSON.parse(this.selectedRequest.request.guideReply);
            }

            const requestId = this.selectedRequest.request.id;
            console.log(requestId);
            console.log(this.selectedRequest.request.reqStatus);

            if (this.selectedRequest.request.reqStatus == 2) {
                console.log(this.selectedRequest.request.reqStatus);
                this.selectedRequest.request.guideReply = this.reply;
                this.isDisabled = true;

            } else {
                this.isDisabled = false;
            }



            // Perform AJAX call to update the request status
            if (this.selectedRequest.request.reqStatus == 0) {
                $.ajax({
                   url: process.env.VUE_APP_API_URL +'/updateCusRequest', // Replace with your actual API endpoint
                    type: 'POST',
                    contentType: 'application/json', // Ensuring JSON format
                    data: JSON.stringify({ requestId: requestId }), // Send data as JSON string
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') // CSRF token if needed
                    },
                    success: (response) => {
                        console.log("Server response:", response); // Log the server response
                        this.selectedRequest.request.reqStatus = '1';
                    },
                    error: (jqXHR, textStatus, errorThrown) => {
                        console.error('Error updating request:', textStatus, errorThrown);
                        alert('Failed to update request status.');
                    }
                });
            }
        },
        makeQuotation(selectedRequest) {
            var user = JSON.parse(localStorage.getItem('user'));
            var userId = user?.id; // Use optional chaining to avoid errors if user is null or undefined
            this.selectedRequest = selectedRequest; // Set the selected request

            const replyData = {
                reqId: this.selectedRequest.request.id,
                cusId: this.selectedRequest.request.cusId,
                userId: userId,
                reply: this.reply,
                status: 0
            };

            // Proceed with the API request using bookingData
            console.log(replyData);

            // Show the loader
            document.getElementById('overlay').style.display = 'block';

            $.ajax({
               url: process.env.VUE_APP_API_URL +'/saveOrgReply', // Replace with your actual API endpoint
                type: 'POST',
                contentType: 'application/json', // Send data as JSON
                data: JSON.stringify(replyData), // Convert the data object to JSON
                success: (response) => {
                    // Log the response for debugging
                    console.log("Server response:", response);

                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Your Qutoation has been sent to the cutomer. They will catch you soon.',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // Code to execute after clicking "OK"
                            // For example, redirecting to another page
                            // window.location.href = '/'; // Replace with your desired URL
                            location.reload();
                        }
                    });
                },
                error: (jqXHR, textStatus, errorThrown) => {
                    console.error('Error saving booking:', textStatus, errorThrown);
                    alert('Error saving booking. Please try again later.');
                }
            });

        }

    }
};
</script>

<style scoped>
.overlay {
    position: fixed;
    /* Fixed position */
    top: 0;
    /* Cover the top */
    left: 0;
    /* Cover the left */
    right: 0;
    /* Cover the right */
    bottom: 0;
    /* Cover the bottom */
    background: rgba(0, 0, 0, 0.5);
    /* Semi-transparent background */
    z-index: 1000;
    /* Ensure it appears above other content */
    display: flex;
    /* Use flex to center the loader */
    justify-content: center;
    /* Center horizontally */
    align-items: center;
    /* Center vertically */
}

.loader {
    position: fixed;
    /* Fixed position */
    left: 50%;
    /* Center horizontally */
    top: 50%;
    /* Center vertically */
    transform: translate(-50%, -50%);
    /* Translate to center */
    z-index: 1000;
    /* Ensure it appears above other content */
}

.custom-scroll {
    max-height: 500px;
    /* Set the height you want */
    overflow-y: auto;
    /* Enable vertical scrolling */
    padding: 15px;
    /* Optional: Add some padding */

}

/* Optional: Style for the scrollbar */
.custom-scroll::-webkit-scrollbar {
    width: 10px;
    /* Width of the scrollbar */
}

.custom-scroll::-webkit-scrollbar-track {
    background: #f1f1f1;
    /* Background of the scrollbar track */
}

.custom-scroll::-webkit-scrollbar-thumb {
    background: #888;
    /* Color of the scrollbar thumb */
    border-radius: 5px;
    /* Rounded corners for the thumb */
}

.custom-scroll::-webkit-scrollbar-thumb:hover {
    background: #555;
    /* Color of the thumb on hover */
}

.fs-xl-2 {
    font-size: 2rem;
}

.chat-container {
    display: flex;
    /* Flexbox layout for side-by-side */
}

.requests-container {
    flex: 0 0 30%;
    /* Fixed size for requests */
    max-height: 500px;
    /* Limit height for scrolling */
    overflow-y: auto;
    /* Enable scrolling for overflow */
    padding-right: 10px;
    /* Spacing between requests and chat */
    border-right: 1px solid #ddd;
    /* Divider line */
}

.requests-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
}

.request-item {
    position: relative;
    /* To position the labels */
    margin-bottom: 20px;
    /* Space between requests */
    cursor: pointer;
    /* Make the item clickable */
}

.request-label {
    position: absolute;
    top: 10px;
    right: 10px;
    padding: 5px 10px;
    border-radius: 20px;
    font-size: 0.8rem;
    color: white;
}

.new-label {
    background-color: #28a745;
    /* Green for new requests */
}

.opened-label {
    background-color: #528bed;
    /* Yellow for opened requests */
}

.reply-label {
    background-color: #cc4aed;
    /* Yellow for opened requests */
}

.closed-label {
    background-color: #ed4a4a;
    /* Yellow for opened requests */
}

.request-bubble {
    background-color: #c6e2f8;
    /* Light green for requests */
    border-radius: 20px;
    padding: 15px;
    max-width: 100%;
    /* Full width of the container */
    word-wrap: break-word;
    /* Wrap long words */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s;
}

.request-bubble:hover {
    transform: scale(1.02);
    /* Slightly enlarge on hover */
}

.request-title {
    font-size: 1.2rem;
    /* Larger font for the title */
    margin: 0 0 10px;
    /* Space below the title */
    color: #333;
    /* Dark color for title */
}

.request-description {
    font-size: 1rem;
    /* Standard font size for the description */
    margin: 0 0 10px;
    /* Space below the description */
    color: #555;
    /* Gray color for description */
}

.chat-display {
    flex: 1;
    /* Take remaining space */
    padding-left: 10px;
    /* Spacing on the left */
}

.nested-list {
    list-style-type: disc;
    /* Bullet points for nested lists */
    margin-left: 20px;
    /* Indentation for nested lists */
    color: #333;
    /* Darker color for better readability */
}

.nested-list li {
    margin-bottom: 5px;
    /* Space between items */
    padding: 5px;
    /* Padding for clickable area */
    transition: background-color 0.2s;
    /* Smooth transition effect */
}

.nested-list li:hover {
    background-color: #e0f7fa;
    /* Light blue on hover */
    border-radius: 5px;
    /* Rounded corners on hover */
}

.message-bubble {
    background-color: #ffffff;
    /* Light gray for messages */
    border-radius: 20px;
    padding: 15px;
    max-width: 90%;
    /* Limit width of messages */
    word-wrap: break-word;
    /* Wrap long words */
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    /* Add shadow for attractiveness */
}

.tour-detail {
    margin-top: 10px;
    /* Space above tour details */
}

.tour-detail-list {
    list-style-type: none;
    /* Remove default list styling */
    padding: 0;
    /* Remove padding */
    margin: 0;
    /* Remove margin */
}

.tour-detail-list li {
    margin-bottom: 5px;
    /* Space between list items */
}

.message-detail {
    margin: 0;
    /* Remove default margin */
}

.no-message {
    text-align: center;
    color: #888;
    /* Grey color for no message */
    flex: 1;
    /* Center in the display */
    display: flex;
    justify-content: center;
    align-items: center;
}

h3 {
    margin: 10px 0;
    /* Spacing above and below section headings */
}
</style>
